var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,_vm._g(_vm._b({key:`${_vm.block.id}-${_vm.block.type}`,tag:"component"},'component',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }